const { capitalize } = require('lodash');
const { TEXT_TRANSFORM, WORDS_SEPARATOR } = require('./constants');

const TEXT_TRANSFORM_HANDLERS = {
    [TEXT_TRANSFORM.CAPITALIZE]: (text) => text.split(WORDS_SEPARATOR).map(capitalize).join(WORDS_SEPARATOR),
    [TEXT_TRANSFORM.UPPERCASE]: (text) => text.toUpperCase(),
    [TEXT_TRANSFORM.LOWERCASE]: (text) => text.toLowerCase(),
    [TEXT_TRANSFORM.SENTENCE_CASE]: capitalize,
    [TEXT_TRANSFORM.NONE]: (text) => text
};

/**
 * Transform a text with a given text letters transformation
 * @param {String} text The text to transform
 * @param {String} transform The transformation to run can be ( capitalize, uppercase, lowercase, sentenceCase )
 * @return {String}
 */
const transformText = (text = '', transform = TEXT_TRANSFORM.CAPITALIZE) => {
    const handler = TEXT_TRANSFORM_HANDLERS[transform];

    if (!handler) {
        return TEXT_TRANSFORM_HANDLERS[TEXT_TRANSFORM.CAPITALIZE](text);
    }

    return handler(text);
};

module.exports = transformText;
